import React, { useState, useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { Form } from "react-bootstrap";
import { getBusinessProfileById } from "../../../services/BusinessProfileService";
import { getStateList } from "../../../services/StateService";
import { getCountryList } from "../../../services/CountryService";
import { AuthService } from "../../../services";
import { BusinessProfileModel } from "../../../components/Model/businessProfileModel";
import { handleConsoleError } from "../../../utils/common-methods";
import { globalConstant } from "../../../constants/globalConstant";
import { toast } from "react-toastify";

const RetailBusinessDetails = ({ handleBusinessProfile }) => {
  const [businessData, setBusinessData] = useState({ ...BusinessProfileModel });
  const [selectedCountryId, setSelectedCountryId] = useState("");
  const [stateList, setStateList] = useState([]);
  const [countryList, setCountryList] = useState([]);
  const [selectedStateId, setSelectedStateId] = useState("");
  const {
    register,
    setValue,
    reset,
    formState: { errors },
  } = useFormContext();
  const setSelectedCountry = (value) => {
    if (value) {
      setSelectedCountryId(value);
    } else {
      setSelectedCountryId("");
      setSelectedStateId("");
    }
  };

  const setSelectedState = (value) => {
    if (value) {
      setSelectedStateId(value);
    } else {
      setSelectedStateId("");
    }
  };
  const filteredStates = stateList.filter(
    (state) => state.countryId === selectedCountryId
  );

  const loginUser = AuthService.getLoginUser();

  const getBusinessProfile = async () => {
    try {
      const userId = loginUser?.id;
      const business = await getBusinessProfileById(userId);
      const stateList = await getStateList();
      const countryList = await getCountryList();

      if (business.isSuccess) {
        business.data.video = "";
        const businessMappedData = {
          ...businessData,
          ...business.data,
        };

        setValue("businessData", businessMappedData);
        setBusinessData(businessMappedData);

        setStateList(stateList.data || []);
        setCountryList(countryList.data || []);
        if (business.data.countryId) {
          setSelectedCountryId(business.data?.countryId);
          setBusinessData((prev) => ({
            ...prev,
            country: countryList.data.find(
              (country) => country.id === business.data.countryId
            ),
          }));
        }
        if (business.data.stateId) {
          setSelectedStateId(business.data?.stateId);
          setBusinessData((prev) => ({
            ...prev,
            state: stateList.data.find(
              (state) => state.id === business.data.stateId
            ),
          }));
        }
      } else {
      }
    } catch (error) {
      handleBusinessProfile(false);
     const message= handleConsoleError(error);
      toast.error(error?.message|| message);
    }
  };
  useEffect(() => {
    getBusinessProfile();
  }, []);
  return (
    <React.Fragment>
      <h2 className="retail-form-hd1">Details</h2>
      <div className="row">
        <div className="col-sm-12 col-lg-6">
          <div className="trader-booking-f">
            <h3>
              Trading Name <span className="text-danger">*</span>
            </h3>
            <Form.Control
              className="effect-4"
              placeholder="Enter your trading name"
              maxLength={100}
              type="text"
              {...register("businessData.businessName", {
                required: "Trading Name is required",
              })}
              defaultValue={businessData?.businessName}
            />
            <span className="focus-border"></span>
          </div>
          {errors.businessData?.businessName && (
            <span className="text-danger mb-3">
              {errors.businessData?.businessName?.message}
            </span>
          )}
        </div>
        <div className="col-sm-12 col-lg-6">
          <div className="trader-booking-f">
            <h3>
              Leagal Business Name <span className="text-danger">*</span>
            </h3>
            <Form.Control
              className="effect-4"
              placeholder="Enter leagal business name"
              maxLength={100}
              type="text"
              {...register("businessData.leagalBusinessName", {
                required: "Leagal business name is required",
              })}
              defaultValue={businessData?.leagalBusinessName}
            />
            <span className="focus-border"></span>
          </div>
          {errors.businessData?.leagalBusinessName && (
            <span className="text-danger">
              {errors.businessData?.leagalBusinessName?.message}
            </span>
          )}
        </div>

        <div className="col-sm-12 col-lg-6">
          <div className="trader-booking-f">
            <h3>
              Contact Legal Name <span className="text-danger">*</span>
            </h3>
            <Form.Control
              className="effect-4"
              placeholder="Enter your contact legal name"
              maxLength={100}
              type="text"
              {...register("businessData.contactlegalname", {
                required: "Contact Legal Name is required",
              })}
              defaultValue={businessData?.contactlegalname}
            />
            <span className="focus-border"></span>
          </div>
          {errors.businessData?.contactlegalname && (
            <span className="text-danger">
              {errors.businessData?.contactlegalname?.message}
            </span>
          )}
        </div>

        <div className="col-sm-12 col-lg-6">
          <div className="trader-booking-f">
            <h3>
              Contact Preferred Name <span className="text-danger">*</span>
            </h3>
            <Form.Control
              className="effect-4"
              placeholder="Enter your contact preferred name"
              maxLength={100}
              type="text"
              {...register("businessData.contactpreferredname", {
                required: "Contact preferred name is required",
              })}
              defaultValue={businessData?.contactpreferredname}
            />
            <span className="focus-border"></span>
          </div>
          {errors.businessData?.contactpreferredname && (
            <span className="text-danger">
              {errors?.businessData?.contactpreferredname?.message}
            </span>
          )}
        </div>

        <div className="col-sm-12 col-lg-6">
          <div className="trader-booking-f">
            <h3>
              State <span className="text-danger">*</span>
            </h3>
            <Form.Control
              as="select"
              {...register("businessData.countryId", {
                required: "State is required",
              })}
              value={selectedCountryId}
              onChange={(e) => {
                setSelectedCountry(e.target.value);
              }}
            >
              <option value="">Select State</option>
              {countryList.map((country) => (
                <option key={country.id} value={country.id}>
                  {country.countryName}
                </option>
              ))}
            </Form.Control>
            <span className="focus-border"></span>
          </div>
          {errors.businessData?.countryId && (
            <span className="text-danger">
              {errors?.businessData?.countryId?.message}
            </span>
          )}
        </div>

        <div className="col-sm-12 col-lg-6">
          <div className="trader-booking-f">
            <h3>
              Country <span className="text-danger">*</span>
            </h3>
            <Form.Control
              as="select"
              {...register("businessData.stateId", {
                required: "Country is required",
              })}
              value={selectedStateId}
              onChange={(e) => {
                setSelectedStateId(e.target.value);
                setSelectedState(e.target.value);
              }}
            >
              <option value="">Select Country</option>
              {filteredStates.map((state) => (
                <option key={state.id} value={state.id}>
                  {state.stateName}
                </option>
              ))}
            </Form.Control>
            <span className="focus-border"></span>
          </div>
          {errors.businessData?.stateId && (
            <span className="text-danger">
              {errors?.businessData?.stateId?.message}
            </span>
          )}
        </div>

        <div className="col-sm-12 col-lg-6">
          <div className="trader-booking-f">
            <h3>
              Address <span className="text-danger">*</span>
            </h3>
            <Form.Control
              className="effect-4"
              placeholder="Enter your address"
              maxLength={200}
              type="text"
              {...register("businessData.address", {
                required: "Address is required",
              })}
            />
            <span className="focus-border"></span>
          </div>
          {errors.businessData?.address && (
            <span className="text-danger">
              {errors?.businessData?.address?.message}
            </span>
          )}
        </div>
        <div className="col-sm-12 col-lg-6">
          <div className="trader-booking-f">
            <h3>
              Town/City <span className="text-danger">*</span>
            </h3>
            <Form.Control
              className="effect-4"
              placeholder="Enter your city"
              maxLength={75}
              type="text"
              {...register("businessData.city", {
                required: "Town/City is required",
              })}
            />
            <span className="focus-border"></span>
          </div>
          {errors.businessData?.city && (
            <span className="text-danger">
              {errors?.businessData?.city?.message}
            </span>
          )}
        </div>

        <div className="col-sm-12 col-lg-6">
          <div className="trader-booking-f">
            <h3>
              Post Code <span className="text-danger">*</span>
            </h3>
            <Form.Control
              className="effect-4"
              placeholder="Enter your post code"
              maxLength={15}
              type="text"
              {...register("businessData.zipCode", {
                required: "Post Code is required",
                pattern: {
                  value: /^[A-Za-z0-9\s-]{3,10}$/,
                  message: "Invalid Postal Code",
                },
              })}
              defaultValue={businessData?.zipCode}
            />
            <span className="focus-border"></span>
          </div>
          {errors.businessData?.zipCode && (
            <span className="text-danger">
              {errors?.businessData?.zipCode?.message}
            </span>
          )}
        </div>

        <div className="col-sm-12 col-lg-6">
          <div className="trader-booking-f">
            <h3>
              Email Address <span className="text-danger">*</span>
            </h3>
            <Form.Control
              className="effect-4"
              placeholder="Enter your email address"
              maxLength={100}
              type="text"
              {...register(
                "businessData.email",
                {
                  required: "Email address is required",
                },
                {
                  pattern: {
                    value: globalConstant.emailRegex,
                    message: "Invalid Email",
                  },
                }
              )}
              defaultValue={businessData?.email}
            />

            <span className="focus-border"></span>
          </div>
          {errors.businessData?.email && (
            <span className="text-danger">
              {errors?.businessData?.email?.message}
            </span>
          )}
        </div>

        <div className="col-sm-12 col-lg-6">
          <div className="trader-booking-f">
            <h3>
              Phone/Mobile Number <span className="text-danger">*</span>
            </h3>
            <Form.Control
              className="effect-4"
              placeholder="Enter your number"
              maxLength={15}
              type="text"
              {...register("businessData.phone", {
                required: "Phone number is required",
                pattern: {
                  value: /^[0-9]\d{8,14}$/,
                  message: "Invalid phone number",
                },
              })}
              defaultValue={businessData?.phone}
            />
            <span className="focus-border"></span>
          </div>
          {errors.businessData?.phone && (
            <span className="text-danger">
              {errors?.businessData?.phone?.message}
            </span>
          )}
        </div>
        <div className="col-sm-12 col-lg-6">
          <div className="trader-booking-f">
            <h3>
              Business Registration Number{" "}
              <span className="text-danger">*</span>
            </h3>
            <Form.Control
              className="effect-4"
              placeholder="Enter your registration number"
              maxLength={8}
              type="text"
              {...register("businessData.businessRegistrationNumber", {
                required: "Registration number is required",
                pattern: {
                  value: /^[a-zA-Z0-9]{8}$/,
                  message:
                    "The registration number must be  alphanumeric and be 8 digits long",
                },
              })}
              defaultValue={businessData?.businessRegistrationNumber}
            />
            <span className="focus-border"></span>
          </div>
          {errors.businessData?.businessRegistrationNumber && (
            <span className="text-danger">
              {errors?.businessData?.businessRegistrationNumber?.message}
            </span>
          )}
        </div>
      </div>
    </React.Fragment>
  );
};
export default RetailBusinessDetails;
